import { render, staticRenderFns } from "./InviterPanel.vue?vue&type=template&id=0cfdf076&scoped=true"
import script from "./InviterPanel.vue?vue&type=script&lang=js"
export * from "./InviterPanel.vue?vue&type=script&lang=js"
import style0 from "./InviterPanel.vue?vue&type=style&index=0&id=0cfdf076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfdf076",
  null
  
)

export default component.exports